import { Inspection } from '@sw-sw/lib-inspection-templates';
import xhrService from '../xhrService';
import { Finding } from './finding';
import db from '../../db/db';
const baseUrl = '/api/projects';

export type ProjectInspection = Omit<Inspection, 'id'> & {
  id: number;
  findings: Array<Finding>;
  pageNumber?: string | number | null;
  pageSize?: number,
  project?: any
  findingDetails?: any;
};

export const projectInspectionApi = {
  index: async (id: number, pageNumber?: string | number | null, pageSize?: number
  ): Promise<any> => {
    const params: {
      p?: string | number | null, pageSize?: number
    } = {};

    if (pageNumber) {
      params.p = pageNumber;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    const offline = navigator.onLine ? false : true;

    if(!offline) {

    return xhrService
      .get(`${baseUrl}/${id}/inspections`, { params })
      .then((response) => response.data);
    }
    else {
       const data= await await db.inspections.where('project_id').equals(Number(id)).sortBy('inspectionNumber')
        .then((inspections:any) => inspections.reverse())
        .catch((e:any) => { 
           console.log("error", e)
           throw e
         });
         
         return {pageData:data,paginationState:{currentPage:1,pageSize:1,numModels:1} }
    }
  },
  indexIds: (id: number): any => {

    return xhrService
      .get(`${baseUrl}/${id}/inspections/Ids`)
      .then((response) => response.data);
  },
};


export default projectInspectionApi;
